<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteLotConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-active="isModalLotsManyVisible" :vm-title='getTitle' style='overflow: scroll;')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=5 v-if="!this.$auth.check('User')")
        b-form-group
          vm-input(:placeholder='$t("lots.square_meter_placeholder")' v-model="newRecord.square_meter" :label='$t("lots.square_meter")')
      vm-col(vm-justify="center", vm-align="center", vm-w=5 v-if="!this.$auth.check('User')")
        b-form-group
          vm-input(:placeholder='$t("lots.discount_voucher_placeholder")' v-model="newRecord.discount_voucher" :label='$t("lots.discount_voucher")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="!this.$auth.check('User')")
        b-form-group
          vm-input(:placeholder='$t("lots.construction_mts_placeholder")' v-model="newRecord.construction_mts" :label='$t("lots.construction_mts")')
      vm-col(vm-justify="center", vm-align="center", vm-w=5 v-if="!this.$auth.check('User')")
        b-form-group
          vm-select(:label='$t("lots.completion_date_month")' :placeholder='$t("lots.completion_date_placeholder_month")' v-model="month" @change="setDate")
            vm-select-item(v-for="(item,index) in months" :key="index" :value="item.text" :text="item.text")
      vm-col(vm-justify="center", vm-align="center", vm-w=5 v-if="!this.$auth.check('User')")
        b-form-group
          vm-select(:label='$t("lots.completion_date_year")' :placeholder='$t("lots.completion_date_placeholder_year")' v-model="year" @change="setDate")
            vm-select-item(v-for="(item,index) in years" :key="index" :value="item" :text="item")
      //- vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("lots.title_placeholder")' :danger="!$v.newRecord.park" v-model="newRecord.park" :label='$t("lots.park")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="!this.$auth.check('User')")
        b-form-group
          .toggle-wrapper
            .form__label
              label.label(style='padding-left: 5px; font-size: .85rem; color: rgba(0,0,0,.7);') Esquina o parque
            .toggle.normal
              input#normal(type="checkbox" v-model="newRecord.park")
              label.toggle-item(for="normal")

      //- vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-text-editor(v-model="newRecord.description" :label="$t('lots.description_placeholder')" :placeholder="$t('lots.description_placeholder')")
      //- vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("lots.cost_placeholder")' v-model="newRecord.reservation_cost" :label='$t("lots.reservation_cost")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:label='$t("lots.status")' :placeholder='$t("lots.status_placeholder")' v-model='newRecord.status')
            vm-select-item(value='1' v-if="!this.$auth.check('User')" text='Disponible')
            vm-select-item(value='2' text='Vendido')
            vm-select-item(value='3' v-if="!this.$auth.check('User')" text='Vendido Online')
            vm-select-item(value='4' v-if="!this.$auth.check('User')" text='No Disponible')
      vm-col(vm-justify="center", vm-align="center", vm-w=12 v-if="!this.$auth.check('User')")
        b-form-group
          vm-select(:label='$t("lots.category")' :placeholder='$t("lots.category_placeholder")' v-model='newRecord.category_id')
            vm-select-item(v-for="(item,index) in categoriesCatalog" :key="index" :value="item.id" :text="item.title")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Lots')

export default {
  name: 'ModalLotsMany',
  props: {
    ids: {
      type: Array,
      default: () => {}
    },
    map_id: {
      type: Number,
      default: 1
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    newRecord: {},
    date_complete: null,
    month: null,
    year: null,
    years: [],
    months: [
      {
        text: 'Enero'
      },
      {
        text: 'Febrero'
      },
      {
        text: 'Marzo'
      },
      {
        text: 'Abril'
      },
      {
        text: 'Mayo'
      },
      {
        text: 'Junio'
      },
      {
        text: 'Julio'
      },
      {
        text: 'Agosto'
      },
      {
        text: 'Septiembre'
      },
      {
        text: 'Octubre'
      },
      {
        text: 'Noviembre'
      },
      {
        text: 'Diciembre'
      }
    ]
  }),
  async created () {
    this.getYears()
  },
  computed: {
    ...mapGetters([
      'isModalLotsManyVisible',
      'lotsCatalog',
      'categoriesCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('lots.add') : this.$t('lots.edit')
    },
    validate_date () {
      return this.date_complete != null
    }
  },
  methods: {
    ...mapActions([
      'addLot',
      'editLotMany',
      'deleteLot',
      'setModalLostManyVisible',
      'loadCategoriesCatalog',
      'loadLots'
    ]),
    setDate () {
      if (this.month != null && this.year != null) this.date_complete = this.month + '-' + this.year
    },
    getYears () {
      let t = this
      const afterYears = new Date().getFullYear() + 10
      for (let index = 0; index < 15; index++) {
        t.years.push(afterYears - index)
      }
      return t.years
    },
    async saveRecord () {
      this.newRecord.link = (this.newRecord.link && this.newRecord.link !== '') && this.addhttp(this.newRecord.link)
      this.newRecord.ids = this.ids
      if (this.validate_date) this.newRecord.completion_date = this.date_complete
      await this.editLotMany(this.newRecord).then(() => {
        this.loadLots({ page: this.page, map_id: this.map_id })
        this.$emit('reset')
      })
      this.newRecord = {}
      this.month = ''
      this.year = ''
    },
    addhttp (url) {
      if (!/^(?:f|ht)tps?:\/\//.test(url)) {
        if (url || url !== '') {
          url = 'http://' + url
        }
      }
      return url
    },
    close () {
      this.setModalLostManyVisible(false)
    }
  },
  watch: {
    isModalLotsManyVisible (flag) {
      if (flag) {
      }
    },
    'newRecord.status' (status) {
      if (parseInt(status) === 1) {
        this.newRecord.fill = '#133a64'
      } else if (parseInt(status) === 2) {
        this.newRecord.fill = '#cc3131'
      } else if (parseInt(status) === 3) {
        this.newRecord.fill = '#975731'
      } else if (parseInt(status) === 4) {
        this.newRecord.fill = '#FFB6B8'
      } else if (parseInt(status) === 5) {
        this.newRecord.fill = '#449bd4'
      } else if (parseInt(status) === 6) {
        this.newRecord.fill = '#f5873c'
      } else if (parseInt(status) === 7) {
        this.newRecord.fill = '#fec649'
      } else if (parseInt(status) === 8) {
        this.newRecord.fill = '#92d14f'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

* {
    box-sizing: border-box;
    &:before, &:after {
        content: '';
        position: absolute;
    }
}

input {
  height: 40px;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 40px;
}

label.toggle-item {
  width: 7em;
  background: #2e394d;
  height: 3em;
  display: inline-block;
  border-radius: 50px;
  margin-top: 10px;
  position: relative;
  transition: all .3s ease;
  transform-origin: 20% center;
  cursor: pointer;
  &:before {
    display: block;
    transition: all .2s ease;
    width: 2.3em;
    height: 2.3em;
    top: .25em;
    left: .25em;
    border-radius: 2em;
    border: 2px solid #88cf8f;
    transition: .3s ease;
  }
}

.normal {
  label {
    background: #af4c4c;
    border: .5px solid rgba(117, 117, 117, 0.31);
    box-shadow: inset 0px 0px 4px 0px rgba(0,0,0,0.2), 0 -3px 4px rgba(0,0,0,0.15);
    &:before {
      border: none;
      width: 2.5em;
      height: 2.5em;
      box-shadow: inset 0.5px -1px 1px rgba(0, 0, 0, 0.35);
      background: #fff;
      transform: rotate(-25deg);
    }
    &:after {
      background: transparent;
      height: calc(100% + 8px);
      border-radius: 30px;
      top: -5px;
      width: calc(100% + 8px);
      left: -2px;
      z-index: 0;
      box-shadow: inset 0px 2px 4px -2px rgba(0,0,0,0.2), 0px 1px 2px 0px rgba(151, 151, 151, 0.2);
    }
  }
}

#normal:checked + label {
  background: #4caf50;
  &:before {
    left: 50px;
  }
}
</style>
